var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultBullet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 4C6.05171e-08 3.30777 0.205272 2.63108 0.589857 2.0555C0.974442 1.47993 1.52107 1.03133 2.16061 0.766421C2.80015 0.501515 3.50388 0.432203 4.18282 0.567252C4.86175 0.7023 5.48539 1.03564 5.97487 1.52513C6.46436 2.01461 6.7977 2.63825 6.93275 3.31718C7.0678 3.99612 6.99849 4.69985 6.73358 5.33939C6.46867 5.97893 6.02007 6.52556 5.44449 6.91014C4.86892 7.29473 4.19223 7.5 3.5 7.5L3.5 4L0 4Z",
    fill: "#36A6A4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 4,
    r: 2.5,
    fill: "#36A6A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBullet);
export default __webpack_public_path__ + "static/media/defaultBullet.0288d6734658e23ea7ec2a7c654b7d1b.svg";
export { ForwardRef as ReactComponent };